export function downloadBlob(
  blob: Blob,
  fileName: string,
  options?: { appendExtension?: boolean },
) {
  if (options?.appendExtension) {
    const extension = getFileExtension(blob);
    // fileName = 'Untitled'
    fileName += `.${extension}`;
  }

  // Force to octet-stream so it triggers download
  const file = new File([blob], fileName, { type: 'application/octet-stream' });
  const fileUrl = window.URL.createObjectURL(file);

  // For Firefox it is necessary to delay revoking the ObjectURL
  setTimeout(() => {
    window.URL.revokeObjectURL(fileUrl);
  }, 100);

  downloadFile(fileUrl, fileName);
}

export function downloadFile(fileUrl: string, fileName: string) {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  link.target = '_blank';
  link.hidden = true;
  // Force to octet-stream so it triggers download
  link.type = 'application/octet-stream';

  document.body.appendChild(link);
  link.click();

  // Delay for Firefox
  setTimeout(() => {
    document.body.removeChild(link);
  }, 0);
}

function getFileExtension(blob: Blob): string {
  let extension: string;

  switch (blob.type) {
    case 'application/pdf':
      extension = 'pdf';
      break;
    case 'text/csv':
      extension = 'csv';
      break;
    case 'application/vnd.ms-excel':
      extension = 'xlsx';
      break;
    case 'application/zip':
      extension = 'zip';
      break;
    default:
      throw new Error(`Unrecognised mime type: '${blob.type}'`);
  }
  return extension;
}
